/**
 * Peak DNA Sticky Add-to-Cart Bar
 * Shows a fixed bottom bar when the main add-to-cart button scrolls out of view
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var stickyBar = document.getElementById('peak-sticky-cart');
    var trigger = document.querySelector('[data-add-to-cart]');
    if (!stickyBar || !trigger) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.add('translate-y-full');
          stickyBar.classList.remove('translate-y-0');
        } else {
          stickyBar.classList.remove('translate-y-full');
          stickyBar.classList.add('translate-y-0');
        }
      });
    }, { threshold: 0 });

    observer.observe(trigger);

    // Sticky bar add-to-cart mirrors the main form
    var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        trigger.click();
      });
    }
  });
})();
